import { render, staticRenderFns } from "./ColorFilterWidget.vue?vue&type=template&id=7c468fd3&"
import script from "./ColorFilterWidget.vue?vue&type=script&lang=js&"
export * from "./ColorFilterWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports